<template>
  <div class="ab-input edit-group edit-group--multiple">
    <input
      class="edit-group-field text-center"
      type="number"
      min="0"
      max="255"
      :value="red"
      @input="$emit('update:red', $event.target.value)"
    />
    <input
      class="edit-group-field text-center"
      type="number"
      min="0"
      max="255"
      :value="green"
      @input="$emit('update:green', $event.target.value)"
    />
    <input
      class="edit-group-field text-center"
      type="number"
      min="0"
      max="255"
      :value="blue"
      @input="$emit('update:blue', $event.target.value)"
    />
    <label>{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'AbRgbInput',
  props: {
    label: String,
    red: [String, Number],
    green: [String, Number],
    blue: [String, Number]
  }
}
</script>

<style lang="scss" scoped>
.edit-group {
  border: 0px;
  margin-bottom: 0px;
}

.ab-input {
  position: relative;
  background: $white;
  border: 2px solid $ui-line-color;
  &:focus-within {
    border: 2px solid $gray;
  }
  input {
    background-image: none !important;
    border: 0px;
    height: auto;
    padding: 14px 20px 13px;
    font-size: 14px;
    color: $dark-gray;
    background-color: transparent;
    width: 100%;
    display: block;
    min-height: 48px;
    &:first-child,
    &:nth-child(2) {
      border-radius: 0px;
      border-right: 2px solid $ui-line-color;
    }
  }
  label {
    position: absolute;
    left: 15px;
    font-size: 12px;
    color: $light-gray;
    top: -11px;
    background: $white;
    padding: 0 5px;
  }
}
</style>
